import { ref } from 'vue'
import type { Router } from 'vue-router'

/**
 * Chargement de page (SP-27). Deux signaux, affichés par `PageLoader` :
 *  - `ready` : faux jusqu'à la première navigation résolue (réhydratation de la session à
 *    froid, premier chunk paresseux) ;
 *  - `slowNavigation` : vrai quand une navigation dépasse `DELAY_MS` — une navigation
 *    instantanée ne fait donc jamais clignoter l'écran.
 */
const DELAY_MS = 200

const ready = ref(false)
const slowNavigation = ref(false)
let timer: ReturnType<typeof setTimeout> | undefined

function clear(): void {
  if (timer !== undefined) clearTimeout(timer)
  timer = undefined
  slowNavigation.value = false
}

export function installNavigationLoading(router: Router): void {
  router.beforeEach(() => {
    clear()
    timer = setTimeout(() => (slowNavigation.value = true), DELAY_MS)
  })
  router.afterEach(clear)
  router.onError(clear)
  router.isReady().finally(() => (ready.value = true))
}

export function useNavigationLoading() {
  return { ready, slowNavigation }
}
